import { PermissionId } from '#/constants/PermissionId';
import { useMemo } from 'react';
import useSWR from 'swr';
import { ResponseObject } from '../interfaces';
import request from '../utils/request';

export interface UserInfo {
  userId: number;
  name: string;
  email: string;
  accountType: number;
  avatar: string;
  permissions?: PermissionId[];
}

/**
 * useUserInfo
 */
export default function useUserInfo() {
  return useSWR(
    '/api/v1/user/info',
    url => request.post<ResponseObject<UserInfo>>(url),
    {
      refreshInterval: 12_000,
      keepPreviousData: true,
    }
  );
}
export function useUserPermission(permissionId: PermissionId) {
  const userInfo = useUserInfo();
  const hasPermission = useMemo(
    () => userInfo?.data?.data.data?.permissions?.includes(permissionId),
    [userInfo, permissionId]
  );
  return hasPermission;
}
